<div class="modal-header">
  <h3 class="modal-title" id="modal-title">{{title}}</h3>
  <button type="button" class="btn-close" aria-describedby="redigera diameterfördelning" (click)="dismiss(false)"></button>
</div>

<div class="p-3">
  <div class="row">
    <rask-input-number class="col-2" [step]="0.1" [label]="texts.diameter" [(ngModel)]="diameter" [rule]="validation.diameter"></rask-input-number>
  </div>
  <div class="row">
    <span class="col-12 pt-2">{{texts.diameterfordelningMinMax | raskStringFormat:min:max}}</span>
  </div>
  <div class="row pt-2">
    <div class="col-12 align-right">
      <rask-button color="primary" (click)="addOrEdit()" [disabled]="canAdd">{{addOrEditButtonText}}</rask-button>
      @if (inputDiameter) {
        <rask-button color="primary" (click)="remove()" negative>{{texts.taBort}}</rask-button>
      }
      <rask-button color="secondary" (click)="dismiss(false)">{{texts.avbryt}}</rask-button>
    </div>
  </div>
</div>
